var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({class:_vm.$style.button},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.$attrs.loading)?_c('Loader'):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }